var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2533_25254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 70C56.5685 70 70 56.5685 70 40C70 23.4315 56.5685 10 40 10C23.4315 10 10 23.4315 10 40C10 56.5685 23.4315 70 40 70Z",
    fill: "#C1E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7311 51.3264H42.0697L32.3379 23.7159H26.1619L16.4395 51.3264H21.7781L24.0594 44.5202H34.4404L36.7264 51.3264H36.7311ZM25.4093 40.4986L29.1394 29.3744H29.3557L33.0951 40.4986H25.4093Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4536 51.745C50.1413 51.745 48.9606 51.5099 47.9164 51.0348C46.8675 50.5644 46.0444 49.8636 45.4376 48.9369C44.8308 48.0103 44.5298 46.872 44.5298 45.5127C44.5298 44.3415 44.7462 43.3772 45.1789 42.6152C45.6116 41.8532 46.1996 41.2417 46.9428 40.7808C47.6907 40.3245 48.5326 39.9765 49.4686 39.7366C50.4094 39.4967 51.383 39.3274 52.3896 39.2192C53.6032 39.0922 54.5862 38.9793 55.3435 38.8758C56.1008 38.7723 56.6511 38.6124 56.9945 38.3913C57.3426 38.1703 57.5119 37.8269 57.5119 37.3612V37.2813C57.5119 36.2653 57.2109 35.4798 56.6088 34.9247C56.0067 34.365 55.1366 34.0875 54.0077 34.0875C52.8129 34.0875 51.8675 34.3509 51.1714 34.8683C50.4752 35.3904 50.0049 36.0066 49.7603 36.7168L45.2024 36.0677C45.5646 34.8071 46.1573 33.7535 46.9804 32.9068C47.8035 32.0602 48.8195 31.4205 50.0143 30.9925C51.209 30.5644 52.5307 30.3528 53.9795 30.3528C54.9766 30.3528 55.9691 30.4703 56.9569 30.7055C57.9446 30.9407 58.8478 31.3217 59.6662 31.8579C60.4846 32.3941 61.1431 33.1185 61.6417 34.0357C62.1403 34.9529 62.3896 36.0959 62.3896 37.4741V51.3358H57.6954V48.4901H57.5354C57.2391 49.0639 56.8252 49.6002 56.289 50.0988C55.7527 50.5973 55.0848 50.9972 54.2805 51.2982C53.4762 51.5992 52.5354 51.7497 51.4583 51.7497L51.4536 51.745ZM52.7189 48.1561C53.6972 48.1561 54.5486 47.9633 55.2683 47.5682C55.9879 47.1778 56.543 46.6604 56.9334 46.0113C57.3238 45.3669 57.5213 44.6613 57.5213 43.8946V41.4534C57.3661 41.5804 57.1121 41.698 56.7452 41.8062C56.383 41.9144 55.9738 42.0084 55.527 42.0884C55.0754 42.1684 54.6333 42.2436 54.1911 42.3048C53.749 42.3659 53.368 42.4224 53.0481 42.4647C52.3191 42.5635 51.6653 42.7281 51.0914 42.9492C50.5176 43.175 50.0613 43.4854 49.732 43.8852C49.3981 44.285 49.2335 44.7977 49.2335 45.428C49.2335 46.3264 49.5627 47.0037 50.2165 47.4647C50.8703 47.9257 51.7076 48.1514 52.7236 48.1514L52.7189 48.1561Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4395 57.6952H62.3896",
    stroke: "#0C57BF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3896 56.5005V58.9511",
    stroke: "#0C57BF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4395 56.5005V58.9511",
    stroke: "#0C57BF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7021 51.3264V23.7159",
    stroke: "#0C57BF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5073 23.7159H69.9579",
    stroke: "#0C57BF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5073 51.3264H69.9579",
    stroke: "#0C57BF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2533_25254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7dd2b5277ce8615ab2f7bfe3d7b6f7e3.svg";
export { ForwardRef as ReactComponent };